import React, { Fragment } from "react";
import NavBar from "../NavBar";

import Avatar from "@material-ui/core/Avatar";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import moment from "moment";
import "moment/locale/es";

const DetallesProyecto = props => {
  // console.log(props);
  const { project, auth } = props;

  if (!auth.uid) return <Redirect to="/entrar" />;
  if (project) {
    let iniciales = project.authorInitials;
    return (
      <Fragment>
        <NavBar />
        <div className="container section nuevo-proyecto">
          <div className="card z-depth-0">
            <div className="card-content">
              <span className="card-title">
                <span style={{ display: "inline-block", margin: "10px" }}>
                  <Avatar
                    style={{
                      width: "30px",
                      height: "30px",
                      fontSize: "12px",
                      background: `${project.color}`
                    }}
                  >
                    {" "}
                    {iniciales}{" "}
                  </Avatar>
                </span>
                {project.title}
              </span>
              <p>{project.content}</p>
            </div>
            <div className="card-action gret lighten-4 grey-text">
              <div>
                Creado por {project.authorFirstName} {project.authorLastName}
              </div>
              <div>{moment(project.createdAt.toDate()).calendar()}</div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <div className="container center viewportCenter">
        <div className="preloader-wrapper active">
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left">
              <div className="circle" />
            </div>
            <div className="gap-patch">
              <div className="circle" />
            </div>
            <div className="circle-clipper right">
              <div className="circle" />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  // console.log(state);
  const id = ownProps.match.params.id;
  const projects = state.firestore.data.projects;
  const project = projects ? projects[id] : null;
  // console.log(projects)
  return {
    project: project,
    auth: state.firebase.auth
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "projects" }])
)(DetallesProyecto);
